import { Alert, Module, ModuleBody, ModuleHead } from "@vjal/ui";

/**
 * F3 — membership-extension note for the reschedule flow. When a reschedule
 * pushes the cohort end-date later, the backend records an idempotent
 * membership-extension ledger row per active membership; the actual
 * membership-api extension stays behind COACHING_MEMBERSHIP_EXTENSION_LIVE_ENABLED.
 * This note keeps that behavior visible in the reschedule surface honestly.
 *
 * Private-to-reschedule leaf module: not a collection owner. Kept out of
 * product-z6-session-panels so that file can export a single session-detail root.
 */
export function MembershipExtensionNote() {
  return (
    <Module span={12}>
      <ModuleHead title="Membership extension" subtitle="Automatic on cohort extension (F3)." />
      <ModuleBody className="space-y-2">
        <Alert variant="info">
          If this reschedule moves the cohort's last session later, participant membership expiry is extended automatically. The
          extension is recorded per membership; the live membership update applies once the membership-extension lane is enabled.
        </Alert>
        <p className="m-0 text-xs leading-5 text-ink-muted">No expiry change is applied when the cohort end-date is unchanged.</p>
      </ModuleBody>
    </Module>
  );
}
